import { canUseDom } from '@sainsburys-tech/boltui-utils'
import { gethostPath } from '../helpers/ContentHelper'
import getHeaders from '../helpers/getHeaders'

async function homepageApi(action, cookies = {}) {
  const { historyData } = action

  if (canUseDom() && Object.keys(historyData).length) {
    return { data: historyData, status: 200 }
  }

  const url = `${gethostPath()}global-api/homepage/cms`
  const res = await fetch(url, getHeaders(cookies))

  let homepageData = {}
  try {
    homepageData = await res.json()
  } catch (err) {
    homepageData = {}
  }

  // TEMP SEO FOOTER CALL
  const seoFooterRes = await fetch('https://www.argos.co.uk/assets/globalnav/megaButtons.json')

  let seoFooter = {}
  try {
    seoFooter = await seoFooterRes.json()
    seoFooter = seoFooter[1]?.seotext || ''
  } catch (err) {
    seoFooter = ''
  }

  const data = {
    meta: {
      title: homepageData.meta.title,
      description: homepageData.meta.description,
      seoFooter,
    },
    data: homepageData.data,
  }

  const resObject = {
    data,
    status: res.status,
    statusText: res.statusText,
  }

  return resObject
}

export default homepageApi
